// extracted by mini-css-extract-plugin
module.exports = {"carouselImage":"QuotesImage_carouselImage__SCEa7"};